import { UnavailableType } from '@web/components/Modal/UnavailableUser/userModal.constant'
import { useUnavailableUserModal } from '@web/components/Modal/UnavailableUser/useUnavailableUserModal'
import sendClickLog from '@web/libs/nlog/click/sendClickLog'
import { ClickEvent } from '@web/types'

export const useHandleClickReviewWrite = ({
  callback,
  nclickCode,
  blockUnavailable = false,
}: {
  callback?: () => void
  nclickCode?: string
  blockUnavailable?: boolean
}) => {
  const { openUnavailableUserModal, user } = useUnavailableUserModal()

  const handleClickReviewWrite = (e: ClickEvent, _callback?: () => void) => {
    e.stopPropagation()
    nclickCode && sendClickLog({ event: e, area: nclickCode })
    if (blockUnavailable && user?.isUnavailableReview) {
      return openUnavailableUserModal(UnavailableType.REVIEW)
    }

    if (callback) {
      callback()
    }

    return _callback?.()
  }

  return handleClickReviewWrite
}
